export const LOADING_MESSAGES = [
  "Chargement des données météorologiques...",
  "Chargement des données topographiques...",
  "Calcul des valeurs des paramètres de la végétation... ",
  "Un instant, Chargement des prédictions en cours...",
];